import { Button, Card, CardBody, CardHeader, Input, Tab, TabPanel, Tabs, TabsBody, TabsHeader, Typography } from '@material-tailwind/react'
import React, { useContext, useState } from 'react'
import { ArrowLeftOnRectangleIcon, LockClosedIcon, } from "@heroicons/react/24/solid"
import { DataContext } from '../context/DataProvider';

function FormLogin() {
  const [type, setType] = useState('member')

  const [input, setInput] = useState({
    email: "",
    password: ""
  })

  const handleChange = (e) => {
    let value = e.target.value
    let name = e.target.name

    setInput({ ...input, [name]: value })

  }

  // const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  const { login } = useContext(DataContext);

  const handleLogin = async (role) => {
    // role.preventDefault();
    try {
      // console.log(input)
      await login(input.email, input.password, role);
      


      //   console.log('Email:', email);
      // console.log('Password:', password);

      // Assuming 'type' is the role ('member' or 'admin')
      //  const userToken = await login(email, password);
      //   console.log('Login successful! Token:', userToken);
      // Redirect or perform other actions after successful login
    } catch (error) {
      console.error('Login failed:', error.message);
      // Handle login failure (e.g., show error message)
    }
  };

  return (
    <div>
      <Card className='w-96 mx-auto my-4'>
        <CardHeader
          color="gray"
          floated={false}
          shadow={false}
          className="m-0 flex justify-center rounded-b-none py-8 px-4 text-center space-x-5"
        >
          <div>
            <ArrowLeftOnRectangleIcon className="w-10" />
          </div>
          <Typography variant="h3" color="white">
            Log in
          </Typography>
        </CardHeader>

        <CardBody>
          <Tabs value={type} className="overflow-visible">

            <TabsHeader className="relative z-0 ">
              <Tab value='member' onClick={() => setType('member')} className={type === 'member' ? 'font-bold' : ''}>
                As Member
              </Tab>
              <Tab value='admin' onClick={() => setType('admin')} className={type === 'admin' ? 'font-bold' : ''}>
                As Admin
              </Tab>
            </TabsHeader>

            <TabsBody
              className='!overflow-x-hidden !overflow-y-visible'
              animate={{
                initial: {
                  x: type === 'member' ? 400 : -400,
                },
                mount: {
                  x: 0,
                },
                unmount: {
                  x: type === 'member' ? 400 : -400,
                },
              }}
            >
              {/* as member form */}
              <TabPanel value='member' className='p-0'>

                <form className='mt-12 flex flex-col gap-4' onSubmit={(e) => e.preventDefault()}>
                  <div>
                    <Typography
                      variant='small'
                      color='blue-gray'
                      className='mb-4 font-semibold'
                    >
                      Email
                    </Typography>
                    <Input
                      onChange={handleChange}
                      value={input.email}
                      name='email'
                      type="email"
                      placeholder="email@email.com"
                      className="!border !border-gray-300 bg-white text-gray-900 shadow-lg shadow-gray-900/5 ring-4 ring-transparent placeholder:text-gray-500 focus:!border-gray-900 focus:!border-t-gray-900 focus:ring-gray-900/10"
                      labelProps={{
                        className: "hidden",
                      }}
                      containerProps={{ className: "min-w-[100px]" }}
                    />
                  </div>

                  <div>
                    <Typography
                      variant='small'
                      color='blue-gray'
                      className='mb-4 font-semibold'
                    >
                      Password
                    </Typography>
                    <Input
                      onChange={handleChange}
                      value={input.password}
                      name='password'
                      type="password"
                      placeholder="******"
                      className="!border !border-gray-300 bg-white text-gray-900 shadow-lg shadow-gray-900/5 ring-4 ring-transparent placeholder:text-gray-500 focus:!border-gray-900 focus:!border-t-gray-900 focus:ring-gray-900/10"
                      labelProps={{
                        className: "hidden",
                      }}
                      containerProps={{ className: "min-w-[100px]" }}
                    />
                  </div>


                  <Button size="lg" className='mt-5'  type="button" onClick={() => handleLogin('member')}>Login as Member</Button>
                  <Typography
                    variant="small"
                    color="gray"
                    className="mt-2 flex items-center justify-center gap-2 font-normal opacity-60"
                  >
                    <LockClosedIcon className="-mt-0.5 h-4 w-4" /> Payments are
                    secure and encrypted
                  </Typography>

                </form>

              </TabPanel>

              {/* as admin form */}
              <TabPanel value='admin' className='p-0' onSubmit={(e) => e.preventDefault()}>

                <form className='mt-12 flex flex-col gap-4'>
                  <div>
                    <Typography
                      variant='small'
                      color='blue-gray'
                      className='mb-4 font-semibold'
                    >
                      Email
                    </Typography>
                    <Input
                    onChange={handleChange}
                    value={input.email}
                    name='email'
                      type="email"
                      placeholder="email@email.com"
                      className="!border !border-gray-300 bg-white text-gray-900 shadow-lg shadow-gray-900/5 ring-4 ring-transparent placeholder:text-gray-500 focus:!border-gray-900 focus:!border-t-gray-900 focus:ring-gray-900/10"
                      labelProps={{
                        className: "hidden",
                      }}
                      containerProps={{ className: "min-w-[100px]" }}
                    />
                  </div>

                  <div>
                    <Typography
                      variant='small'
                      color='blue-gray'
                      className='mb-4 font-semibold'
                    >
                      Password
                    </Typography>
                    <Input
                    onChange={handleChange}
                    value={input.password}
                    name='password'
                      type="password"
                      placeholder="******"
                      className="!border !border-gray-300 bg-white text-gray-900 shadow-lg shadow-gray-900/5 ring-4 ring-transparent placeholder:text-gray-500 focus:!border-gray-900 focus:!border-t-gray-900 focus:ring-gray-900/10"
                      labelProps={{
                        className: "hidden",
                      }}
                      containerProps={{ className: "min-w-[100px]" }}
                    />
                  </div>

                  <Button size="lg" className='mt-5' type="button" onClick={() => handleLogin('admin')}>Login As Admin</Button>
                  <Typography
                    variant="small"
                    color="gray"
                    className="mt-2 flex items-center justify-center gap-2 font-normal opacity-60"
                  >
                    <LockClosedIcon className="-mt-0.5 h-4 w-4" /> Payments are
                    secure and encrypted
                  </Typography>



                </form>

              </TabPanel>

            </TabsBody>

          </Tabs>
        </CardBody>
      </Card>
    </div>
  )
}

export default FormLogin